import React, { Component } from "react";
import { Radar } from "react-chartjs-2";

export default class RadarChart extends Component {
  render() {
    const data = {
      labels: ["GLOBAL", "CONTENU", "ORGANISATION", "DELIVRANCE", "EMOTION"],
      datasets: [
        {
          label: "Pitch",
          backgroundColor: "rgba(179,181,198,0.2)",
          borderColor: "rgba(179,181,198,1)",
          pointBackgroundColor: "rgba(179,181,198,1)",
          pointBorderColor: "#fff",
          pointHoverBackgroundColor: "#fff",
          pointHoverBorderColor: "rgba(179,181,198,1)",
          data: this.props.data
        }
      ]
    };
    const options = {
      scale: {
        ticks: {
          beginAtZero: true,
          min: 0,
          max: 5,
          stepSize: 1
        }
      }
    };
    return <Radar data={data} options={options} height={60} />;
  }
}
